import React from 'react'
import { IconButton } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'

import ProcedureFiltersModal from './ProcedureFiltersModal'
import { TProcedureFiltersProps } from './ProcedureFilters.types'
import { useProcedureFiltersLogic } from './useProcedureFiltersLogic'

const ProcedureFilters: React.FC<TProcedureFiltersProps> = ({
  filters,
  surgeries,
  onApplyFilters,
  onClearFilters,
  isAnyFilterActive,
}) => {
  const { isOpen, handleOpen, handleClose } = useProcedureFiltersLogic()

  return (
    <>
      <IconButton
        onClick={handleOpen}
        size="large"
        sx={{
          color: isAnyFilterActive ? 'primary.main' : 'grey.500',
          background: 'none',
          border: 'none',
          boxShadow: 'none',
          borderRadius: '50%',
          transition: 'background 0.2s',
          '&:hover': {
            backgroundColor: 'primary.lightest',
          },
          p: 1,
        }}
      >
        <FilterListIcon fontSize="medium" />
      </IconButton>

      <ProcedureFiltersModal
        open={isOpen}
        filters={filters}
        onClose={handleClose}
        surgeries={surgeries}
        onApplyFilters={onApplyFilters}
        onClearFilters={onClearFilters}
      />
    </>
  )
}

export default ProcedureFilters
